import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '@/views/LoginView.vue'
import ChatView from '@/views/ChatView.vue'
import ChatAppLayout from '@/layouts/ChatAppLayout.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: ChatAppLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Chat',
        component: ChatView
      },
      {
        path: 'reportes',
        name: 'Reportes',
        component: () => import('@/views/ReportesView.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'incentivos',
        name: 'Incentivos',
        component: () => import('@/views/IncentivosView.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('yapp_token')

  if (to.meta.requiresAuth && !token) {
    next({ name: 'Login' })
  } else if (to.name === 'Login' && token) {
    next({ name: 'Chat' })
  } else if (to.meta.requiresAdmin) {
    try {
      const userData = JSON.parse(localStorage.getItem('yapp_user_data') || '{}')
      const hasAccess = userData.clinics === null || userData.permissions?.all_clinics === true
      if (!hasAccess) {
        next({ name: 'Chat' })
        return
      }
    } catch {
      next({ name: 'Chat' })
      return
    }
    next()
  } else {
    next()
  }
})

export default router
